import Vue from "vue";

Vue.directive("watermark", (el, binding) => {
  function addWaterMarker(str, parentNode, font, textColor, account) {
    // 水印文字，父元素，字体，文字颜色
    var can = document.createElement("canvas");
    // parentNode.appendChild(can);
    can.width = 500;
    can.height = 220;
    can.style.display = "none";
    var cans = can.getContext("2d");
    cans.rotate((-20 * Math.PI) / 180);
    cans.font = font || "16px Microsoft JhengHei";
    cans.fillStyle = textColor || "rgba(180, 180, 180, 0.3)";
    cans.textAlign = "left";
    cans.textBaseline = "Middle";
    // let textStr = str
    let textStr = "";
    if (str && str != "undefined") {
      textStr = str;
    }
    if (account && account != "undefined") {
      textStr += `  ${account}`;
    }
    console.log(textStr);
    console.log("++++++++++");
 
    cans.fillText(textStr, can.width / 4.5, can.height / 2);
    // console.log("+++")
    // console.log(can.width / 4.5)
    // console.log(can.width/3)
    // parentNode.style.backgroundImage = "url(" + can.toDataURL("image/png") + ")";
    const base64Url = can.toDataURL();
    let watermarkDiv = null;
  
    if (document.getElementsByClassName("watermark").length>0) {
      watermarkDiv = document.getElementsByClassName("watermark")[0];
      
    } else {
      watermarkDiv = document.createElement("div");
      watermarkDiv.setAttribute("class", "watermark");
    }
    parentNode.insertBefore(watermarkDiv, parentNode.firstChild);
    // const watermarkDiv = document.createElement('div')
    // watermarkDiv.setAttribute("class","watermar")
    watermarkDiv.setAttribute(
      "style",
      `
          position:absolute;
          top:0;
          left:0;
          width:100%;
          height:100%;
        //   width:20000px;
        //   height:20000px;
          z-index:100000;
          pointer-events:none;
          background-repeat:repeat;
          background-image:url('${base64Url}')`
    );
    parentNode.style.position = "relative";
    // parentNode.insertBefore(watermarkDiv, parentNode.firstChild);
  }
  addWaterMarker(
    binding.value.text,
    el,
    binding.value.font,
    binding.value.textColor,
    binding.value.account
  );
});
